export default  class Practicum {
  date: string;
  formattedDate: string;
  items: [];
  text: string;
}
